import * as React from 'react';
import styled from "styled-components";

const Box = styled.rect`
    padding-top:80px;
    display:block;
`;

export class BadLink extends React.Component<{}, {}> {

    render() {
        return <Box>
            <h5>This link is expired or broken.</h5>
        </Box>;
    }
}